import { isCalculatorParams, } from "../components/fleet-calculator/calculator-types";
import { isVoyageParams, } from "../components/voyage/voyage-types";
export var isRootParams = function (params) {
    return isCalculatorParams(params) || isVoyageParams(params);
};
